import { render } from "./ScoreDistributionGraph.vue?vue&type=template&id=12d0618c&scoped=true"
import script from "./ScoreDistributionGraph.vue?vue&type=script&lang=js"
export * from "./ScoreDistributionGraph.vue?vue&type=script&lang=js"

import "./ScoreDistributionGraph.vue?vue&type=style&index=0&id=12d0618c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12d0618c"]])

export default __exports__